import React from "react";
import { connect } from "@irati/store";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import { PaymentProvider } from "@irati/types";
import { Radio, CustomNodeRenderer } from "@irati/ui/src/FormItem";
import visa from "@irati-web/payments/src/images/visa.svg";
import mastercard from "@irati-web/payments/src/images/mastercard.svg";
import authentication from "@irati/auth";
import PayByWalletCheckBox from "./PayByWalletCheckBox";
import { CreditCardImage, BoldMessage, HeaderWrapper } from "./styled";
var PayByCreditCard = function (props) {
    var walletAmount = props.walletAmount, currency = props.currency, wallet = props.wallet, isWalletSelected = props.isWalletSelected, isCardSelected = props.isCardSelected, onSelectWallet = props.onSelectWallet;
    var availableWalletBalance = wallet.availableBalance * 100;
    var boldWalletAmount = (React.createElement(BoldMessage, null,
        React.createElement(FormattedMessage, { id: "platform.wallet.components.payByWallet.useBalance.innerText", values: { amount: React.createElement(FormattedCurrency, { value: availableWalletBalance, currency: currency }) } })));
    var creditCardOptions = [
        {
            customNode: (React.createElement(Flex, { margin: 1, direction: "column" },
                React.createElement(Flex, { alignItems: "center" },
                    React.createElement(FormattedMessage, { id: "platform.wallet.components.payByWallet.payByCreditCard", values: { amount: boldWalletAmount } }),
                    React.createElement(CreditCardImage, { src: mastercard }),
                    React.createElement(CreditCardImage, { src: visa })))),
            value: PaymentProvider.AdyenClassic,
            whiteSpace: "wrap"
        }
    ];
    return (React.createElement(HeaderWrapper, { selected: isCardSelected },
        React.createElement(Radio, { rowRenderer: CustomNodeRenderer, name: "paymentMethodCreditCard", value: isCardSelected && PaymentProvider.AdyenClassic, options: creditCardOptions, onChange: function () { return props.onSelectCard(PaymentProvider.AdyenClassic); } }),
        authentication.apps("wallet.users") && (React.createElement(Flex, { marginLeft: "48px" },
            React.createElement(PayByWalletCheckBox, { onChange: function () { return onSelectWallet(!isWalletSelected); }, value: isWalletSelected, currency: currency, availableBalance: availableWalletBalance, remainingBalance: availableWalletBalance - walletAmount })))));
};
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({
        wallet: wallet
    });
};
export default connect(mapStateToProps)(PayByCreditCard);
